/**
 * --------------------------------------------------------------------------
 * Photo Carousel (v1.0.0):
 * Licensed under WTFPL
 * --------------------------------------------------------------------------
 */
window.$ = window.$ ? window.$ : window.jQuery

const PhotoCarousel = (($) => {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  
  const NAME = 'photo_carousel'
  const VERSION = '1.0.0'
  const DATA_KEY = 'photo_carousel'
  const JQUERY_NO_CONFLICT = $.fn[NAME]
  
  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  
  class PhotoCarousel {
    constructor (element) {
      this._element = $(element)
      this._dots = this._element.find('.photo-carousel-content-dots')
      this._content = this._element.find('.photo-carousel-content')
      
      this.init()
    }
    
    init () {
      //  delete all image srcset
      this._content.find('img').attr('srcset', '')
      
      //  call slick
      this._content.slick({
        infinite: true,
        slidesToShow: 1,
        adaptiveHeight: true,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        dots: true,
        appendDots: this._dots,
        prevArrow: '<button class="photo-carousel-arrows-btn photo-carousel-arrows-btn-prev"><span class="icon-arrow_left"></span></button>',
        nextArrow: '<button class="photo-carousel-arrows-btn photo-carousel-arrows-btn-next"><span class="icon-arrow_right"></span></button>'
      })
      
    }
    
    // Static
    
    static _jQueryInterface () {
      return this.each(function () {
        const $element = $(this)
        let data = $element.data(DATA_KEY)
        
        if (!data) {
          data = new PhotoCarousel(this)
          $element.data(DATA_KEY, data)
        }
        
      })
    }
    
  }
  
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(() => {
    PhotoCarousel._jQueryInterface.call($('aside .photo-carousel'))
    
    window.setTimeout(() => $(window).resize(), 2000)
  })
  
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  
  $.fn[NAME] = PhotoCarousel._jQueryInterface
  $.fn[NAME].Constructor = PhotoCarousel
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT
    return PhotoCarousel._jQueryInterface
  }
  
  return PhotoCarousel
})($)

export default PhotoCarousel
